import { type BDMenuItem } from '@bizzdesign/shared/models';
import { type ProductAnalyticsService } from '@bizzdesign/shared/services';

export function createSupportMenuItems(
  productAnalyticsService: ProductAnalyticsService,
): BDMenuItem[] {
  return [
    {
      id: 'user-feedback',
      labelKey: 'support.feedback',
      tScope: 'featureLayout',
      icon: 'ui-message-pen',
      command: () => productAnalyticsService.sendEvent('feedback_clicked'),
    },
    {
      id: 'help-articles',
      labelKey: 'support.helpArticles',
      tScope: 'featureLayout',
      icon: 'ui-help',
      command: () => {
        productAnalyticsService.sendEvent('help_articles_clicked');
        openLinkInNewTab(
          'https://help.bizzdesign.com/articles/#!unify-help/unify-help',
        );
      },
    },
    {
      id: 'contact-support',
      labelKey: 'support.contactSupport',
      tScope: 'featureLayout',
      icon: 'ui-envelope',
      command: () => {
        productAnalyticsService.sendEvent('contact_support_clicked');
        openLinkInNewTab(
          'https://bizzdesign.atlassian.net/servicedesk/customer/portal/242',
        );
      },
    },
  ];
}

function openLinkInNewTab(url: string): void {
  window.open(url, '_blank', 'noopener,noreferrer');
}
